// extracted by mini-css-extract-plugin
module.exports =  {"input":"b429494557--input--qT5Pp"};